import { Card, CardBody, Select } from '@chakra-ui/react'
import { FC } from 'react'

import Loader from '../../../Loader'
import {
  useSystemSettings,
  useUpdateSystemSettings,
} from '../../../shared/useSystemSettings'
import { Title } from '../../../utils'

type Props = { organizationUid: string }

export const ObfuscateSpeech: FC<Props> = ({ organizationUid }) => {
  const { data: systemSettings } = useSystemSettings(organizationUid)
  const { mutate: updateSystemSettings } =
    useUpdateSystemSettings(organizationUid)

  if (systemSettings === undefined) return <Loader />
  return (
    <Card>
      <CardBody>
        <Title>Obfuscate Speech</Title>
        <Select
          maxW="330px"
          mt={4}
          value={systemSettings.speech.obfuscateSpeech ? 'true' : 'false'}
          onChange={(e) =>
            updateSystemSettings({
              speech: {
                obfuscateSpeech: e.target.value === 'true',
              },
            })
          }
        >
          <option value="true">Enabled</option>
          <option value="false">Disabled</option>
        </Select>
      </CardBody>
    </Card>
  )
}
